import React from "react";
import {
  FaPlane,
  FaGraduationCap,
  FaHospital,
  FaFlask,
  FaTrain,
  FaStore,
  FaBuilding
} from "react-icons/fa";

import { motion } from "framer-motion";
import "./sectors.css";

const sectors = [
  { icon: <FaPlane />, title: "Airports", desc: "Interiors and MEP works for airport lounges" },
  { icon: <FaGraduationCap />, title: "Education", desc: "Durable furniture for schools and colleges" },
  { icon: <FaHospital />, title: "Healthcare", desc: "Modular furniture for hospitals and clinics" },
  { icon: <FaFlask />, title: "Laboratory", desc: "Lab furniture built for safety and precision" },
  { icon: <FaTrain />, title: "Mass Transit Systems", desc: "Façade and civil works for metro and stations" },
  { icon: <FaStore />, title: "Retail", desc: "Display and storage for retail outlets" },
  { icon: <FaBuilding />, title: "Workspaces", desc: "Ergonomic furniture for productive offices" },
];

function Sectors() {
  return (
    <section className="sectors">
      <div className="container">
        <h2 className="section-title">Sectors</h2>

        <div className="sectors-grid">
          {sectors.map((item, index) => (
            <motion.div
              key={index}
              className="sector-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <div className="sector-icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Sectors;